import { BehaviorSubject } from "rxjs";
export class HeaderModel {
  title: string;
  backDefaultHref?: string = "/app/home";
  userSettingsBreakpoint?: number;
  segments?: {
    name: string;
    value: string;
    permission?: boolean;
    permissionKeys?: string[];
    badge?: number;
  }[] = [];
  activeSegment?: string;
  segmentsChangeFunc?: (event: CustomEvent<any>) => void;
  mobileSegments?: {
    name: string;
    value: string;
    permission?: boolean;
    permissionKeys?: string[];
    translated?: boolean;
    badge?: number;
  }[] = [];
  shouldHasMobileSegments?: boolean;
  showMobileSegmentsOnDesktop?: boolean = false;
  mobileSegmentsChangeFunc?: (event: CustomEvent<any>) => void;
  showOnTablet?: boolean;
  showRightButtonsOnlyOnMobile?: boolean = false;
  hideRightButtonsTextOnMobile?: boolean = false;
  rightButtons?: {
    iconName?: "trash" | "settings" | "save" | "filter";
    name?: string;
    iconUrl?: string;
    class?: string;
    fill?: string;
    rolePermission: [string];
    permission?: boolean;
    onClick: () => void;
    counter?: BehaviorSubject<number>;
  }[];
  visibility?: boolean;
  showToggleMenuButton?: boolean;
  showUser?: boolean = true;
}
